
import { Link } from 'react-router-dom';
//import { useTranslation } from 'react-i18next';
import { SEO } from '../utils/seo';

export default function NotFound() {
  //const { t } = useTranslation();
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://balamtech.com';

  return (
    <>
      <SEO
        title="404 - Page Not Found | Balam Technology"
        description="The page you're looking for doesn't exist. Return to Balam Technology homepage for custom software development services."
        url={`${siteUrl}/404`}
        type="website"
      />
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white flex items-center justify-center px-4">
        <div className="text-center max-w-md mx-auto">
          <div className="mb-8">
            <div className="w-24 h-24 bg-gradient-to-r from-blue-600 to-blue-700 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
              <i className="ri-error-warning-line text-4xl text-white"></i>
            </div>
            <h1 className="text-6xl font-bold text-blue-900 mb-4 font-poppins">404</h1>
            <h2 className="text-2xl font-semibold text-blue-800 mb-4 font-poppins">
              Page Not Found
            </h2>
            <p className="text-blue-600 mb-8 font-inter">
              The page you're looking for doesn't exist or has been moved.
            </p>
          </div>
          
          <div className="space-y-4">
            <Link
              to="/"
              className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-semibold rounded-lg hover:from-blue-700 hover:to-blue-800 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer font-inter whitespace-nowrap"
            >
              <i className="ri-home-line mr-2"></i>
              Go Home
            </Link>
            
            <div className="flex justify-center space-x-4 text-sm">
              <Link
                to="/#services"
                className="text-blue-600 hover:text-blue-800 transition-colors duration-300 cursor-pointer font-inter"
              >
                Services
              </Link>
              <span className="text-blue-300">•</span>
              <Link
                to="/#about"
                className="text-blue-600 hover:text-blue-800 transition-colors duration-300 cursor-pointer font-inter"
              >
                About
              </Link>
              <span className="text-blue-300">•</span>
              <Link
                to="/#contact"
                className="text-blue-600 hover:text-blue-800 transition-colors duration-300 cursor-pointer font-inter"
              >
                Contact
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
